import { render } from "./OnboardingCompanyPage.vue?vue&type=template&id=22b2efb8&scoped=true"
import script from "./OnboardingCompanyPage.vue?vue&type=script&lang=js"
export * from "./OnboardingCompanyPage.vue?vue&type=script&lang=js"

import "./OnboardingCompanyPage.vue?vue&type=style&index=0&id=22b2efb8&lang=scss"
import "./OnboardingCompanyPage.vue?vue&type=style&index=1&id=22b2efb8&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b2efb8"]])

export default __exports__